import { Button } from "components/atoms/button/button";
import { Modal } from "components/modal/modal";
import { ModalSize } from "components/modal/modal.types";
import Image from "next/legacy/image";
import CocoCustomerService from "public/assets/slot-selection/coco-customer-service.svg";
import {
  ModalDescription,
  ModalTitle,
  ModalWrapper,
  WhatsappInformation
} from "./modal-confirmation-call-me-back.styles";
import { ModalConfirmationCallMeBackProps } from "./modal-confirmation-call-me-back.types";

const ModalConfirmationCallMeBack: React.FC<
  ModalConfirmationCallMeBackProps
> = (props) => {
  const { isOpen, onClose, onSubmitCallMe } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={ModalSize.Tiny}>
      <ModalWrapper>
        <Image
          src={CocoCustomerService}
          width={100}
          height={100}
          alt="coco-customer-service"
        />
        <ModalTitle>Ada kendala? Kakak Siaga akan hubungi kamu</ModalTitle>
        <ModalDescription>Kakak Siaga siap sedia di jam kerja</ModalDescription>

        <Button onClick={onSubmitCallMe} variant="primary" isFullWidth>
          Telepon aku, Kak
        </Button>

        <WhatsappInformation>
          Chat di WA ke nomor <strong>081119954075</strong>
        </WhatsappInformation>
      </ModalWrapper>
    </Modal>
  );
};

export { ModalConfirmationCallMeBack };
